import { render, staticRenderFns } from "./landing_page.vue?vue&type=template&id=79dddaa8"
import script from "./landing_page.vue?vue&type=script&lang=js"
export * from "./landing_page.vue?vue&type=script&lang=js"
import style1 from "./landing_page.vue?vue&type=style&index=1&id=79dddaa8&prod&lang=css"
import style2 from "./landing_page.vue?vue&type=style&index=2&id=79dddaa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports